export default {
  slug: "jetbrains-for-data",
  code: "JBD",
  label: "JetBrains for Data",
  shortLabel: "JetBrains",
  altLabel: "JetBrains for Data",
  hideProductName: true,
  hasGrid: true,
  logoFamily: "data",
};
